module.exports = __webpack_public_path__ + "img/default-thumb.37ab969d.png";